import React, { useState } from "react";
import { Link, Route, Switch, useLocation } from "react-router-dom";
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'

const Routing = ({ menu, namespace }) => (
    <Switch>
        {
            menu
                .filter(item => item.component || item.submenu)
                .map(item => 
                    item.submenu ?
                        item.submenu
                            .filter(sub => sub.component)
                            .map(sub => 
                                <Route exact={ sub.path === '' ? true : false } path={ `/app/${namespace}/${item.path}/${sub.path}` }>
                                    <sub.component namespace={ namespace } parent={ item.path } />
                                </Route>
                            )
                    :
                    <Route exact={ item.path === '' ? true : false } path={ `/app/${namespace}/${item.path}` }>
                        <item.component path={ `/app/${namespace}/${item.path}` } />
                    </Route>
                )
        }
    </Switch>
)

const SubMenu = ({ item, namespace, active, setActive, page }) => {
    return (
        <span >
            <span onClick={ () => setActive(item.title) } className={`flex cursor-pointer items-center p-2 text-base font-normal text-gray-900 ${active ? 'text-yellow-600 border-l-4 border-yellow-500 h-8' : ''} hover:bg-gray-100`}>
                <span className="mr-3">{item.title}</span>
                {
                    active ? <BiChevronUp /> : <BiChevronDown />
                }
            </span>

            <ul className={ `ml-2 space-y-2 ${active ? 'h-auto' : 'h-0' } transition-05s overflow-hidden`}>
                {
                    item.submenu.map(sub =>
                        <Link to={`/app/${namespace}/${item.path}/${sub.path}`} className={`flex items-center p-2 text-base font-normal text-gray-900 ${page === sub.path ? 'text-yellow-600 h-8' : ''} hover:bg-gray-100`}>{sub.title}</Link>
                    )
                }
            </ul>
        </span>
    )
}

export const MenuItem = ({ condition, children }) => <span className={`flex items-center p-2 text-base font-normal text-gray-900 ${ condition ? 'text-yellow-600 border-l-4 border-yellow-500 h-8' : ''} hover:bg-gray-100`}>{ children }</span>

export const SideMenu = ({ menu, namespace }) => {
    const [active, setActive] = useState()

    const location = useLocation()
    const split = location.pathname.split('/')

    const page = split[3]
    const page2 = split[4]

    return (
        <ul className="space-y-2">
            {
                menu.map(item => {
                    let condition = page === item.path
                    
                    return (
                        <li>
                            {
                                item?.submenu ?
                                    <SubMenu 
                                        item={ item } 
                                        page={ page2 } 
                                        namespace={ namespace } 
                                        setActive={ setActive } 
                                        active={ active === item.title } />
                                : 
                                    <Link className="w-full" to={`/app/${namespace}/${item?.path}`} onClick={ () => setActive(item?.title) }>
                                        { typeof item?.title === 'function' ? <item.title condition={ condition } /> : <MenuItem condition={ condition }>{ item?.title }</MenuItem> }
                                    </Link>
                            }
                            {/* <Link to={ `/app//${item.path}` } className={ `flex items-center p-2 text-base font-normal text-gray-900 ${ page === item.path ? 'text-yellow-600 border-l-4 border-yellow-500 h-8' : '' } hover:bg-gray-100` }>{ item.title }</Link> */}
                        </li>
                    )
                })
            }
        </ul>
    )
}

export default Routing